/**Dependencies */
import React from 'react'

/**Images */
import whatsApp from '../images/whatsApp.png';

/**Componente para mostrar el icono de WhatsApp flotante*/
export const WhatsAppFloat = () => {
  return (
    <div className="float-wsp">
        <a target="_blank" href="https://wa.me/7772035097"><img src={whatsApp} alt="" className='wsp-icon'/></a>
    </div>
  )
}
